import Vue from "vue";
import Vuex from "vuex";
import login from "./login";
import user from "./user";
import patient from "./patient";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sideMenu: false,
    api: "https://apicdss.tamanaba.com/",
    apiGuide: "https://apibookcdssdev.nitrosbase.com/",
    apiFile: "https://apicdssdev.nitrosbase.com",
    apiImg: "https://apicdssdev.nitrosbase.com",
    sections: [],
  },
  getters: {
    apiUrl: (state) => state.api,
    apiGuide: (state) => state.apiGuide,
    apiFile: (state) => state.apiFile,
    getSideMenu: (state) => state.sideMenu,
    apiImg: (state) => state.apiImg,
  },
  mutations: {
    setSideMenu(state, val) {
      state.sideMenu = val;
    },
  },
  modules: {
    login,
    patient,
    user,
  },
});
